var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"ModalCreateCronjob","title":"Créer une tâche programmée","header-bg-variant":"kalkin-1","header-text-variant":"light","size":"xl","hide-footer":""}},[_c('FormCronjob',{on:{"saved":_vm.onSaved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }